import { memo, useCallback } from 'react';

import { FileStatusIconProgressing, FileStatusTitle } from '@air/feature-file-status/ui';

import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneCancelOrHideButton } from '~/components/FileStatusTrackingPane/TaskPaneCancelOrHideButton';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { type DuplicateAssetTask, type GetInProgressMetadata } from '~/store/tasks/types';

export type DuplicateAssetTaskInProgressPanelItemProps = {
  localTaskId: string;
  metadata: Pick<GetInProgressMetadata<DuplicateAssetTask>, 'sourceItemTitle' | 'isFile'>;
  onCancel: (localTaskId: string) => void;
};

export const DuplicateAssetTaskInProgressPanelItem = memo(
  ({ localTaskId, onCancel, metadata: { sourceItemTitle, isFile } }: DuplicateAssetTaskInProgressPanelItemProps) => {
    const { ui2026 } = useTemporaryFeatureFlags();
    const itemLabel = isFile ? 'file' : 'asset';
    const handleCancel = useCallback(() => onCancel(localTaskId), [localTaskId, onCancel]);
    const title = ui2026 ? `Duplicating ${itemLabel}` : `Duplicating ${itemLabel} "${sourceItemTitle}"`;

    return (
      <PaneItemTW
        avatar={<FileStatusIconProgressing size={getTaskPaneFileStatusIconSize(ui2026)} />}
        title={<FileStatusTitle data-testid="DUPLICATING_ASSET_TITLE">{ui2026 ? `${title}…` : title}</FileStatusTitle>}
        buttons={<TaskPaneCancelOrHideButton onClick={handleCancel} />}
      />
    );
  },
);

DuplicateAssetTaskInProgressPanelItem.displayName = 'DuplicateAssetTaskInProgressPanelItem';
